import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { isTablet } from '../../../utilities'
import AddressPatientInformation from '../addressPatientInformationSection/AddressPatientInformationSection.component'
import BasicPatientInformation from '../basicPatientInformationSection/BasicPatientInformationSection.component'
import { getEmailDetailsSelector, getPhoneDetailsSelector } from '../selectors'
import { IPhoneDetails, IEmailDetails } from '../store/patientDemographics.types'
import { getPatientSearchState } from '../../patientSearch/selectors/patientSearch.selector'
import { IonLoading } from '@ionic/react'

const PatientDemographicsContent: React.FC = () => {
  const emailDetails = useSelector(getEmailDetailsSelector)
  const phoneDetails = useSelector(getPhoneDetailsSelector)
  const { isPatientDataLoading } = useSelector(getPatientSearchState)

  const getScrollableContent = () => {
    if (!isTablet()) {
      return document.getElementById('main-pn-content') as HTMLIonContentElement
    } else {
      return document.getElementById('main-content') as HTMLIonContentElement
    }
  }

  const usePreviousPhoneDetails = (phoneDetails: IPhoneDetails) => {
    const ref: React.MutableRefObject<IPhoneDetails | undefined> = useRef()
    useEffect(() => {
      ref.current = phoneDetails
    })
    return ref.current
  }

  const usePreviousEmailDetails = (emailDetails: IEmailDetails) => {
    const ref: React.MutableRefObject<IEmailDetails | undefined> = useRef()
    useEffect(() => {
      ref.current = emailDetails
    })
    return ref.current
  }

  const prevPhoneDetails = usePreviousPhoneDetails(phoneDetails)

  const prevEmailDetails = usePreviousEmailDetails(emailDetails)

  useEffect(() => {
    if (prevPhoneDetails && phoneDetails.length > prevPhoneDetails?.length) {
      getScrollableContent()?.scrollByPoint(0, 400, 500)
    }
  }, [phoneDetails.length, prevPhoneDetails])

  useEffect(() => {
    if (prevEmailDetails && emailDetails.length > prevEmailDetails?.length) {
      getScrollableContent()?.scrollToBottom(500)
    }
  }, [emailDetails.length, prevEmailDetails])

  return (
    <>
      {isPatientDataLoading && <IonLoading data-testid='Loader' isOpen animated showBackdrop spinner={'crescent'} />}
      {!isPatientDataLoading && (
        <>
          <BasicPatientInformation />
          <AddressPatientInformation />
        </>
      )}
    </>
  )
}

export default PatientDemographicsContent
